module.exports = __webpack_public_path__ + "assets/img/driver-btn-3c936a56.png";